<template>
  <el-tabs class="recomed my_tabs" type="border-card">
    <el-tab-pane label="推荐搭配">
      <div class="item">
        <img class="img" v-lazy="effectImg" alt="图片加载失败" />
        <p class="name com_hidden">{{currentMix.mixName}}</p>
        <div class="sprice">市场参考价<span class="line_th">￥{{ currentMix.salePrice | priceValue }}</span></div>
        <div class="cprice" v-if="$cookies.isKey('ACCESS_TOKEN')">￥{{currentMix.clientSalePrice | priceValue}}</div>
        <div class="cprice cur_pointer" v-else @click.prevent.stop="updateLogin">登录查看多比价</div>
      </div>

      <div class="item" v-for="(v,i) in recomMix" :key="i">
        <div class="show" v-if="i<=2">
          <router-link :to="{path:'/goodsDetails/'+v.serNo+'.html'}" target="_blank" class="mask">
            <img class="img" v-lazy="v.mainPreviewImageFilePath" alt="图片加载失败" />
          </router-link>
          <el-checkbox v-model="v.checked">{{v.mixName}}</el-checkbox>
          <div class="sprice">市场参考价<span class="line_th">￥{{ v.salePrice | priceValue }}</span></div>
          <div class="cprice" v-if="$cookies.isKey('ACCESS_TOKEN')">￥{{v.clientSalePrice | priceValue}}</div>
          <div class="cprice cur_pointer" v-else @click.prevent.stop="updateLogin">登录查看多比价</div>
        </div>
      </div>

      <div class="add_icon">
        <i class="el-icon-plus"></i>
      </div>

      <div class="total">
        <p class="first"><span class="num">{{selectGoodsNum}}</span> 件商品搭配总价</p>
        <p class="second num"> ¥ {{totalPrice | priceValue}}</p>
        <el-button class="btn" type="primary" @click="addShoppingCart">
          加入购物车
        </el-button>
      </div>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import { BatchAddShopCart } from "@/pages/page1/api/modules/shoppingCart";
export default {
  props: {
    currentMix: {
      type: Object,
      default: () => {},
    },
    effectImg: {
      type: String,
      default: "",
    },
    recomMix: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  mounted() {
    // 源数据没有checked
    this.recomMix.forEach((v, i) => {
      this.$set(v, "checked", false);
    });
  },
  methods: {
    addShoppingCart() {
      if (this.$cookies.isKey("ACCESS_TOKEN")) {
        let params = {
          regionCode: localStorage.getItem("_regionCode"),
          shoppingCartList: this.selectList,
        };
        BatchAddShopCart(params).then((res) => {
          let newUrl = this.$router.resolve("/shopCart");
          window.open(newUrl.href, "_self");
        });
      } else {
        this.$emit("noLogin");
      }
    },
    updateLogin() {
      this.$emit("noLogin");
    },
  },
  computed: {
    selectGoodsNum() {
      let res = 1;
      this.recomMix.forEach((v) => {
        if (v.checked) res += 1;
      });
      return res;
    },
    totalPrice() {
      let res = this.currentMix.salePrice || 0;
      this.recomMix.forEach((v) => {
        if (v.checked) res += v.salePrice;
      });
      return res;
    },
    selectList() {
      let arr = [];
      arr.push({
        goodsMixId: this.currentMix.id,
        goodsCount: 1,
      });
      this.recomMix.forEach((v) => {
        if (v.checked) {
          arr.push({
            goodsMixId: v.id,
            goodsCount: 1,
          });
        }
      });
      return arr;
    },
  },
};
</script>

<style lang="less" scoped>
.recomed {
  width: 100%;
  margin-top: 26px;
  box-sizing: border-box;
  border: none;
  box-shadow: none;
  /deep/ .el-tabs__header {
    .el-tabs__item {
      padding: 0 30px !important;
      font-size: 16px;
    }
    .is-active {
      background: #ff9e00;
    }
  }
  /deep/ .el-tabs__content {
    padding: 34px 48px 0 0;
    .el-tab-pane {
      display: flex;
      flex-wrap: wrap;
      position: relative;
      .item {
        width: 206px;
        margin-right: 34px;
        font-weight: 500;
        font-size: 14px;
        line-height: 1;
        overflow: hidden;
        &:first-child {
          margin-right: 72px;
        }
        .img {
          display: block;
          height: 206px;
        }
        .name {
          color: #696969;
          line-height: 36px;
        }
        .el-checkbox {
          color: #696969;
          display: flex;
          align-items: center;
          .el-checkbox__input {
            margin-top: 2px;
            display: inline-block;
            width: 14px;
          }
          .el-checkbox__label {
            display: inline-block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: calc(100% - 14px);
            font-size: 14px;
            line-height: 36px;
          }
        }
        p {
          color: #d00000;
        }
        .money {
          font-size: 24px;
        }
      }
      .add_icon {
        font-size: 60px;
        color: #a7a7a7;
        font-weight: 500;
        position: absolute;
        left: 213px;
        top: 86px;
      }
      .total {
        position: absolute;
        top: 4px;
        right: 0;
        font-size: 14px;
        color: #a7a7a7;
        line-height: 1;
        .num {
          color: #d00000;
        }
        .first {
          margin-bottom: 14px;
        }
        .second {
          margin-bottom: 18px;
        }
        .btn {
          width: 134px;
          height: 36px;
          background: #ff9e00;
          padding: 0;
          border-radius: 0;
        }
      }
    }
  }
  .mask {
    position: relative;
    display: block;
    &::after {
      display: block;
      content: "";
      width: 100%;
      height: 100%;
      background: #000000;
      opacity: 0.2;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
      display: none;
    }
    &:hover {
      &::after {
        display: block;
      }
    }
  }
}
</style>